import { postMypageUserFcmToken } from "../../api/v1/user/fcm-token/post"
import { MypageUserFcmTokenPostInputModel } from "../../api/v1/user/fcm-token/PostInputModel"

/** FCM token 登録 */
export const registerFcmToken = async (token: string): Promise<void> => {
  return postMypageUserFcmToken(new MypageUserFcmTokenPostInputModel(token))
}
